import { SwapAndBridgeToToken } from '@ambire-common/interfaces/swapAndBridge'
import { TokenResult } from '@ambire-common/libs/portfolio'

const getTokenId = (token: SwapAndBridgeToToken | TokenResult) => {
  let id = `${token.address}.${token.chainId}`

  // If it's a SwapAndBridgeToToken (no flags), just return address + chainId
  if (!('flags' in token)) return id

  const { onGasTank, rewardsType } = token.flags

  if (onGasTank) id += '.onGasTank'
  if (rewardsType) id += `.rewardsType=${rewardsType}`

  return id
}

/**
 * A picker row synthesized from a static registry (LibertySwap inputs, shield
 * inputs, …) because the account has no portfolio entry for that token. Its
 * `amount` is filler `0n`, NOT a scanned balance — the real on-chain balance is
 * unknown until the portfolio discovers (or the user imports) the token, which
 * on some chains never happens automatically. Consumers must suppress the
 * balance instead of rendering a misleading "0". See Trello #378.
 */
export type PlaceholderBalanceToken = TokenResult & { isPlaceholderBalance?: boolean }

/**
 * False for the synthesized rows described above — their `0` is "unknown", not
 * "empty", so no balance should be shown for them.
 */
const getHasKnownBalance = (token: SwapAndBridgeToToken | TokenResult): boolean =>
  !(token as PlaceholderBalanceToken).isPlaceholderBalance

export { getHasKnownBalance, getTokenId }
